import React, { useState, FC } from "react";
import { Formik } from "formik";
import { RegistrationShape } from "@containers/Auth/interface/AuthForm.interface";
import { FormProps } from "@shared/interfaces";
import { FormGenerator, Button } from "@shared/components";

import { validationSchema, fields, getInitValues } from "./formHelpers";

import "./index.scss";

const RegistrationForm: FC<FormProps<RegistrationShape>> = (props) => {
  const [formValues] = useState(getInitValues(null));

  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        props.submitHandler && props.submitHandler(values);
        setSubmitting(false);
      }}
      validateOnMount={true}
      validateOnChange={true}
      initialValues={formValues}
    >
      {(formikProps) => (
        <>
          <FormGenerator fields={fields} formikProps={formikProps} className="registration-form">
            <Button
              className="auth-modal__submit"
              type="submit"
              isDisabled={props.loading || !validationSchema.isValidSync(formikProps.values)}
            >
              Sign Up
            </Button>
          </FormGenerator>
        </>
      )}
    </Formik>
  );
};

export default RegistrationForm;
